<div class="profile-wrapper" :class="brandClass()">
    <ProfileNav @doLogout="doLogout" class="nav-bar mobile" :isMobile="true" v-model="sectionContent" />
    <hr class="profile-header-delimiter first-delimiter" :class="brandClass()">
    <ProfileHeader :editDisabled="isEditDisabled" :user="user"></ProfileHeader>
    <hr class="profile-header-delimiter">
    <main class="content-wrapper" :class="$c('show_profile_header') ? 'addHeight' : ''">
        <div class="sidebar">
            <ProfileNav @doLogout="doLogout" class="nav-bar desktop" :isMobile="false" v-model="sectionContent" />
        </div>

        <div class="content">
            <!--  PERSONAL DATA SECTION  -->
            <div class="personaldata" v-if="sectionContent === enums.profilePages.PERSONAL_DATA">
                <OneHead :brandClass="brandClass()" :isHeader="false">
                    <template v-slot:title>{{$toUpperCase($t("profile_personal_data_header_title"))}}</template>
                    <template v-slot:subtitle>{{$t("profile_personal_data_header_subtitle")}}</template>
                </OneHead>

                <hr>
                <ProfilePersonalInformation v-if="$c('show_personal_info')" v-on:isEditMode="checkEditMode($event)" :editDisabled="isEditDisabled" :user="user" :salutationsFromServer="salutationsFromServer" :gendersFromServer="gendersFromServer" :nationalitiesFromServer="nationalitiesFromServer"/>
                <ProfileEmails v-if="$c('show_personal_email')" v-on:isEditMode="checkEditMode($event)" :editDisabled="isEditDisabled" :user="user" v-model:sectionContent="sectionContent" />
                <ProfilePhoneNumbers  v-if="$c('show_personal_phones')" v-on:isEditMode="checkEditMode($event)" :editDisabled="isEditDisabled" :user="user" />
                <ProfileAddressesNoFSM v-if="$c('show_personal_addresses_no_fsm')" v-on:isEditMode="checkEditMode($event)" :editDisabled="isEditDisabled" :user="user" v-on:autosave="autosave($event)"/>
                <ProfileAddresses v-if="$c('show_personal_addresses')" v-on:isEditMode="checkEditMode($event)" :editDisabled="isEditDisabled" :user="user" v-on:autosave="autosave($event)"/>
            </div>
            <!--  ACCOUNT DETAILS SECTION  -->
            <div class="accountdetails" v-if="sectionContent===enums.profilePages.ACCOUNT_DATA">
                <OneHead :brandClass="brandClass()" :isHeader="false">
                    <template v-slot:title>{{$toUpperCase($t("profile_account_data_header_title"))}}</template>
                    <template v-slot:subtitle>{{$t("profile_account_data_header_subtitle")}}</template>
                </OneHead>
                <hr>
                <ProfilePersonalId v-if="$c('show_personal_id')" :editDisabled="isEditDisabled" :user="user" :passkeyEntries="passkeyEntries"/>
                <ProfilePassword v-if="$c('show_personal_password')" :editDisabled="isEditDisabled" :user="user" />
                <ProfilePasskey @getPasskeys="getPasskeysPromise" v-if="$c('show_passkey_section') && passkeyServiceIsWorking" :editDisabled="isEditDisabled" :passkeyEntries="passkeyEntries" :passkeyCount="passkeyCount" />
                <ProfileLocalization v-if="$c('show_localization_section')" :editDisabled="isEditDisabled" :user="user" />
                <ProfileLinkedServices v-if="$c('show_linked_services')" :user="user" />
                <ProfileAccountDeletion v-if="$c('show_delete_account_section')" :editDisabled="isEditDisabled" :user="user" />
            </div>
            <!--  ESIM SECTION  -->
            <div class="esim" v-if="sectionContent===enums.profilePages.ESIM">
                <EsimSection :user="user" @sectionContent="sectionContent=$event"></EsimSection>
            </div>
            <!--  VEHICLES SECTION  -->
            <div class="vehicles" v-if="sectionContent===enums.profilePages.VEHICLES">
                <VehiclesSection :user="user"></VehiclesSection>
            </div>
            <!--  CONSENTS SECTION  -->
            <div class="consents" v-if="sectionContent===enums.profilePages.CONSENTS">
                <ConsentsSection></ConsentsSection>
            </div>
            <!--  DEALERS SECTION  -->
            <div class="dealers" v-if="sectionContent===enums.profilePages.DEALERS">
                <DealersSection :editDisabled="isEditDisabled" :user="user" v-on:autosave="autosave($event)"></DealersSection>
            </div>
            <!--  POLICY CONSENTS POP UP  -->
            <OneAlert :brandClass="brandClass()" class="policy_consents_popup" v-if="policyToAccept.length > 0 && !showIntermediateRegistrationScreen" :title="$t('profile_terms_and_condition_title')" :content="$t('profile_terms_and_condition_subtitle')" :button_confirm_label="$t('profile_terms_and_condition_accept_button')"
                :button_confirm_disabled="policyNotCompliant" :button_cancel_label="$t('profile_cancel_button')" @confirm="updatePolicy" @close="onClose" :showCloseButton="false">
                <template v-slot:internal-content>
          <PolicyConsentsPopup
            :policyDocuments="policyToAccept"
            @onClose="onClose"
            @onPolicyCreated="policyPopupFormCreated($event)"
            @onPolicyUpdated="policyPopupFormUpdated($event)"
          ></PolicyConsentsPopup>
        </template>
            </OneAlert>
            <!--  INTERMEDIATE REGISTRATION SCREEN  -->
            <OneAlert :brandClass="brandClass()" v-if="showIntermediateRegistrationScreen" class="intermediate_registration_popup" :title="$t('profile_intermediate_registration_title')" :content="$t('profile_intermediate_registration_subtitle')" :subsubtitle="$t('profile_intermediate_registration_warning')"
                :button_confirm_label="$t('profile_submit_button')" :button_cancel_label="$t('profile_cancel_button')" :button_confirm_disabled="!intermediateForm || intermediateForm.$invalid" @close="doLogout" @confirm="onSaveClickedInIntermediateRegistrationScreen">
                <template v-slot:internal-content>
          <IntermediateRegistrationScreen
            :salutationsFromServer="salutationsFromServer"
            :user="user"
            @formChanged="intermediateRegistrationScreenFormChanged($event)"
          >
          </IntermediateRegistrationScreen>
        </template>
            </OneAlert>

        </div>

    </main>
    <div v-if="!isEditMode && thereAreDifferences() && sectionContent===enums.profilePages.PERSONAL_DATA" class="update-profile-banner" :class="brandClass()">
        <OneButton :brandClass="brandClass()" style="width: 328px;" :type="'primary'" :label="$t('profile_update_profile_button')" @click="!isLoading && submit()" />
    </div>


</div>